module.exports = __webpack_public_path__ + "img/bank-logos.258c4151.svg";